var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-footer no-translate",attrs:{"id":"Footer"}},[_vm._v("\n  Copyright ©\n  "+_vm._s(new Date().getFullYear())+" "),_c('b',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.copyRightName)+". All rights reserved.")]),_vm._v(" Version "),_c('b',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.version))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f295356","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 